/**
 * Type ladder for chat surfaces. Size encodes importance: the assistant's answer is the
 * largest text in the thread and the composer never outranks it. The user's own words and
 * every compact context (the Ask AI popover, starter prompt chips) sit one step down, and
 * telemetry (work summaries, dispositions, tickers) stays quietest via the Mantine xs/sm
 * props.
 *
 * Values are px because the app's Mantine fontSizes ladder (sm=12, md=14) tops out below
 * comfortable conversational prose; chat surfaces share this ladder instead of ad-hoc sizes.
 */
export const CHAT_TYPE = {
  /** Assistant answers and the full-page composer. */
  prose: 15,
  /** User messages, popover prose and composer, starter prompt chips. */
  compact: 14,
} as const;
